import types from '@/vuex/documento/actions-types'
import documentos from '@/utils/documentos'

const API_URL = process.env.API_BASE_URL

const actions = {
  [types.SET_DOCUMENTO]: ({ commit }, payload) => {
    commit(types.SET_DOCUMENTO, payload)
  },

  [types.GET_DOCUMENTO]: async ({ commit }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando dados do documento.' }, {root: true})
    try {
      commit(types.SET_DOCUMENTO, { documento: undefined })
      const response = await documentos.getDocument(payload.docId)
      commit(types.SET_DOCUMENTO, { documento: response.data })
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: error.body && error.body.message ? error.body.message : 'Não foi possível buscar dados do documento' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando dados do documento.' }, {root: true})
    }
  },

  [types.GET_EMAIL_INTERESSADO]: async ({ commit }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando email do interessado.' }, {root: true})
    try {
      commit(types.SET_EMAIL_INTERESSADO, { emailInteressado: undefined })
      const response = await documentos.getEmailInteressado(payload.tipoInteressado, payload.idInteressado)
      commit(types.SET_EMAIL_INTERESSADO, { emailInteressado: response.data.email ? response.data.email : undefined })
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível buscar o email do interessado deste documento' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando email do interessado.' }, {root: true})
    }
  },

  [types.SET_EMAIL_INTERESSADO]: ({ commit }, payload) => {
    commit(types.SET_EMAIL_INTERESSADO, payload)
  },

  [types.GET_PRESENTE_CAIXA_POSTAL]: async ({ commit }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Verificando presença na caixa postal' }, {root: true})
    try {
      const parameters = { numeroDocumento: payload.documento.numero }
      const response = await documentos.getListaDocumentosCaixaPostal(parameters)
      const listaFiltrada = response.data.filter(item => item.idDocumento === payload.documento.idDocumento)
      if (listaFiltrada.length > 0) commit(types.SET_PRESENTE_CAIXA_POSTAL, { presenteCaixaPostal: true })
      else commit(types.SET_PRESENTE_CAIXA_POSTAL, { presenteCaixaPostal: false })
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível verificar se o documento está presente na caixa postal' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Verificando presença na caixa postal' }, {root: true})
    }
  },

  [types.GET_RAIZ_PRESENTE_CAIXA_POSTAL]: async ({ commit }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Verificando presença de documentos agregadores na caixa postal' }, {root: true})
    try {
      let current = payload.documento
      while (current.idDocumentoAgregador) current = (await documentos.getDocument(current.idDocumentoAgregador)).data
      const parameters = { numeroDocumento: current.numero }
      const response = await documentos.getListaDocumentosCaixaPostal(parameters)
      const listaFiltrada = response.data.filter(item => item.idDocumento === current.idDocumento)
      if (listaFiltrada.length > 0) commit(types.SET_RAIZ_PRESENTE_CAIXA_POSTAL, { raizPresenteCaixaPostal: true })
      else commit(types.SET_RAIZ_PRESENTE_CAIXA_POSTAL, { raizPresenteCaixaPostal: false })
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível verificar presença de documentos agregadores na caixa postal' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Verificando presença de documentos agregadores na caixa postal' }, {root: true})
    }
  },

  [types.SET_PRESENTE_CAIXA_POSTAL]: ({ commit }, payload) => {
    commit(types.SET_PRESENTE_CAIXA_POSTAL, payload)
  },

  [types.RECEBER_DOCUMENTO]: async ({ commit, dispatch }, payload) => {
    const config = {
      textoPergunta: 'Receber o documento?',
      textoConteudo: `${payload.documento.tipo ? payload.documento.tipo : payload.documento.tipoDocumento} número "${payload.documento.numero ? payload.documento.numero : payload.documento.numeroDocumento}" está presente em sua caixa postal mas ainda não foi recebido. Deseja receber este documento?`,
      textoNao: 'Não',
      textoSim: 'Receber'
    }
    if (await dispatch(types.CONFIRMAR, { ...config }, {root: true})) {
      commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Recebendo documento' }, {root: true})
      try {
        await documentos.receberDocumento(payload.documento.idDocumento)
        commit(types.SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Documento recebido com sucesso' }, {root: true})
        return true
      } catch (error) {
        commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível receber o documento' }, {root: true})
        return false
      } finally {
        commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Recebendo documento' }, {root: true})
      }
    }
  },

  [types.GET_URL_CONSOLIDACAO]: async ({ commit }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Solicitando consolidação...' }, {root: true})
    commit(types.SET_URL_CONSOLIDACAO, {consolidacaoURL: null})
    try {
      const response = await documentos.solicitaConsolidacao(payload.parameters)
      commit(types.SET_URL_CONSOLIDACAO, {consolidacaoURL: API_URL + 'consolidacao/' + response.body.uuid})
      localStorage.setItem('PROTOCOLO' + response.body.uuid, JSON.stringify(response.body))
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível gerar a solicitação de consolidação' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Solicitando consolidação...' }, {root: true})
    }
  },

  [types.GET_PDF_CAPA]: async ({ commit }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Gerando capa' }, {root: true})
    try {
      const response = await documentos.getPDFCapa(payload.parameters)
      const blob = new Blob([response.body], {type: 'application/pdf'})
      const blobURL = (window.URL || window.webkitURL).createObjectURL(blob)
      window.open(blobURL, '_blank')
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível gerar o comprovante' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Gerando capa' }, {root: true})
    }
  },

  [types.GET_PDF_COMPROVANTE_PROTOCOLIZACAO]: async ({ commit }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Gerando comprovante de protocolização' }, {root: true})
    try {
      const response = await documentos.getPDFComprovanteProtocolizacao(payload.parameters)
      const blob = new Blob([response.body], {type: 'application/pdf'})
      const blobURL = (window.URL || window.webkitURL).createObjectURL(blob)
      window.open(blobURL, '_blank')
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível gerar o comprovante' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Gerando comprovante de protocolização' }, {root: true})
    }
  },

  [types.ENVIAR_COMPROVANTE_PROTOCOLIZACAO_POR_EMAIL]: async ({ commit }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Enviando comprovante de protocolização para: ' + payload.parameters.destinatario }, {root: true})
    try {
      await documentos.enviarComprovanteProtocolizacaoPorEmail(payload.parameters)
      commit(types.SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Comprovante de protocolização enviado para ' + payload.parameters.destinatario }, {root: true})
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível enviar o comprovante' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Enviando comprovante de protocolização para: ' + payload.parameters.destinatario }, {root: true})
    }
  },

  [types.SALVAR_TAGS]: async ({ commit, dispatch }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Salvando marcadores' }, {root: true})
    try {
      await documentos.salvarTags(payload.idDocumento, payload.stringTags)
      commit(types.SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Marcadores salvos com sucesso' }, {root: true})
      const response = await documentos.getDocument(payload.idDocumento)
      commit(types.SET_DOCUMENTO, { documento: response.data })
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: error.body.message }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Salvando marcadores' }, {root: true})
    }
  },

  [types.FAVORITAR_DOCUMENTO]: async ({ commit, dispatch }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Adicionando documento aos favoritos' }, {root: true})
    try {
      await documentos.favoritarDocumento(payload.idDocumento)
      commit(types.SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Documento adicionado aos favoritos com sucesso' }, {root: true})
      return true
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível adicionar o documento aos favoritos' }, {root: true})
      return false
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Adicionando documento aos favoritos' }, {root: true})
    }
  },

  [types.DESFAVORITAR_DOCUMENTO]: async ({ commit, dispatch }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Removendo documento dos favoritos' }, {root: true})
    try {
      await documentos.desfavoritarDocumento(payload.idDocumento)
      commit(types.SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Documento removido dos favoritos com sucesso' }, {root: true})
      return true
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível remover o documento dos favoritos' }, {root: true})
      return false
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Removendo documento dos favoritos' }, {root: true})
    }
  },

  [types.GET_CONSOLIDACOES]: async ({ commit }, usuario) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando consolidações recentes' }, {root: true})
    try {
      const response = await documentos.buscarConsolidacoes()
      if (response.data) {
        commit(types.SET_LISTA_CONSOLIDACOES, { listaConsolidacoes: response.data })
      } else {
        let localStorageConsolidacoes = []
        for (let i = 0; i < localStorage.length; i++) {
          let key = localStorage.key(i)
          let item = JSON.parse(localStorage.getItem(key))
          if (key.startsWith('PROTOCOLO') && !item.idUsuario) {
            localStorageConsolidacoes.push(item)
          }
        }
        let result = await documentos.buscarConsolidacaoPorUUID(localStorageConsolidacoes)
        commit(types.SET_LISTA_CONSOLIDACOES, { listaConsolidacoes: result.data })
      }
    } catch (error) {
      console.log(error)
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível buscar as consolidações recentes' }, {root: true})
      return false
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando consolidações recentes' }, {root: true})
    }
  }

}

export default actions
